import { useState, useEffect } from "react";
import {
  Avatar,
  Button,
  Card,
  Form,
  Input,
  Row,
  Col,
  Select,
  Radio,
  DatePicker
} from "antd";
import moment from "moment";


import { GlobalOutlined } from "@ant-design/icons";

import { ContactField, util  } from '@seims/shared';

import candidateLookup from "../../services/candidateLookupService";
import commonLookup from "../../services/commonLookupService";
import { recordError } from "../../utils/logService";

const PersonalInformation = ({ data }) => {
  const [titles, setTitles] = useState([]);
  const [races, setRaces] = useState([]);
  const [genders, setGenders] = useState([]);
  const [address, setAddress] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showAddressInfo, setshowAddressInfo] = useState(false);
  const [contactValue, setContactValue] = useState("");
  const [altContactValue, setAltContactValue] = useState("");
  const [active, setActive] = useState(true);
  const [demographyData, setDemographyData] = useState();
  const [provinces, setProvince] = useState([]);
  const [activities, setActivities] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);

  const formItemLayout = {
    layout: "vertical",
  };

  const { Option } = Select;
  const { Meta } = Card;
  const [form] = Form.useForm();
  const formName = "PersonalInformationForm";

  useEffect(() => {
    getTitles();
    getRaces();
    getGenders();
    getProvinces();
    getPreNYSActivity();
  }, []);

  useEffect(() => {
    getDemographics();
  }, [titles, genders, races, data]);


  const getDemographics = async () => {

    try {
      //!! ENSURE TO USE AWAIT ON A LIVE API
      //!! CHECK STATUS CODE 200/201
      setActive(false);


      if (!util.isEmpty(data)) {
        setActive(true);

        const selectedTitle = titles.find(
          (record) => record.key === data.title
        );

        const selectedGender = genders.find(
          (record) => record.key === data.gender
        );

        const selectedActivity = activities.find(
          (record) => record.key === data.preNYSActivity
        );

        const selectedRace = races.find((record) => record.key === data.race);

        const selectedPreferredProvince = provinces.find(
          (record) => record.key === data.preferredProvince
        );
        const selectedHomeProvince = provinces.find(
          (record) => record.key === data.homeProvince
        );

        form.setFieldsValue({
          id: data.id,
          title: selectedTitle,
          firstname: data.name,
          lastname: data.surname,
          idNumber: data.idNumber,
          email:data.email,
          gender: selectedGender,
          homeProvince: selectedHomeProvince,
          preferredProvince: selectedPreferredProvince,
          preNYSActivity: selectedActivity,
          genderOther: data.gender_other,
          race: selectedRace,
          dob: moment(data.dob),
          disability: data.disability,
          alternativePersonFullName: data.alternativePersonFullName,
        });
        setDemographyData(data);
        setAltContactValue(data.alternativeCellNumber);
        setContactValue(data.cellNumber);
        setAddress(data.address);
        setshowAddressInfo(true);
        setIsDisabled(data.disability);
        setActive(false);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const onNameBlur = (e) => {
    const { value, name } = e.target;
    const textValue = util.toPascalText(value);
    form.setFieldsValue({ [name]: textValue });
  };

  const onHomeProvinceChange = (selected) => {
    const selectedProvince = provinces.find((record) => record.key == selected);
    form.setFieldsValue({ homeProvince: selectedProvince });
  };

  const handleCancel = () => {
    setShowModal(false);
  };

  const handleModalSubmit = (values) => {
    setAddress(values);
    setShowModal(false);
    setshowAddressInfo(true);
  };
  const getTitles = async () => {
    try {
      const response = await commonLookup.getTitles();
      if (response) {
        const { data } = response;
        setTitles(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getRaces = async () => {
    try {
      const response = await commonLookup.getRaces();
      if (response) {
        const { data } = response;
        setRaces(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getGenders = async () => {
    try {
      const response = await commonLookup.getGenders();
      if (response) {
        const { data } = response;
        setGenders(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getProvinces = async () => {
    try {
      const response = await commonLookup.getProvinces();
      if (response) {
        const { data } = response;
        setProvince(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const getPreNYSActivity = async () => {
    try {
      const response = await candidateLookup.getPreNYSActivity();
      if (response) {
        const { data } = response;
        setActivities(data);
      }
    } catch (error) {
      recordError(error);
    }
  };

  const handleCellNumberChange = (value) => {
    form.setFieldsValue({ cellphone: value, contactcellphone: value });
  };

  const onIdChange = (e) => {
    const { value } = e.target;
    form.setFieldsValue({ idNumber: util.toNumeric(value) });
  };

  const disabilityLabel = `${isDisabled ? "Yes" : "No"}`;

  return (
    <>
      {/* <PageHeader
        title="Personal Information"
        subTitle="View personal info"
      ></PageHeader>
      <Divider /> */}
      <h1 className="center-align">Personal Information</h1>
      <p className="sub-title center-align">
        View Personal Information
      </p>
      <br />
      <Form {...formItemLayout} name={formName} form={form} disabled>
        <Row>
          <Col xs={24} md={10}>
            <Form.Item name="title" label="Title" rules={[{ required: false }]}>
              <Select>
                {titles.map((title) => (
                  <Option key={title.key} value={title.value}>
                    {title.value}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col xs={24} md={10}>
            <Form.Item
              name="firstname"
              label="Firstname"
              rules={[{ required: true, message: "Please enter firstname" }]}
            >
              <Input name="firstname" onBlur={onNameBlur} />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={10}>
            <Form.Item
              name="lastname"
              label="Lastname"
              rules={[{ required: false }]}
            >
              <Input name="lastname" onBlur={onNameBlur} />
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col xs={24} md={10}>
            <Form.Item
              name="idNumber"
              label="ID no"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Input
                name="idNumber"
                onChange={onIdChange}
                minLength={13}
                maxLength={13}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={10}>
            <Form.Item
              name="disability"
              label="Disability"
            >
              <Radio.Group name="disability"
              >
                <Radio key={1} value={true}>Yes</Radio>
                <Radio key={2} value={false}>No</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col xs={24} md={10}>
            <Form.Item
              name="gender"
              label="Gender"
              rules={[{ required: false }]}
            >
              <Select>
                {genders.map((gender) => (
                  <Option key={gender.key}>{gender.value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={10}>
            <Form.Item name="race" label="Race" rules={[{ required: false }]}>
              <Select>
                {races.map((race) => (
                  <Option key={race.key} value={race.value}>
                    {race.value}
                  </Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col xs={24} md={10}>
            <Form.Item
              name="dob"
              label="Date of birth"
              rules={[{ required: false }]}
            >
              <DatePicker />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col xs={24} md={10}>
            <Form.Item
              name="cellphone"
              label="Cellphone"
              rules={[
                {
                  required: true,
                  message: "Please enter your cellphone",
                },
              ]}
            >
              <ContactField
                contactValue={contactValue}
                onContactChange={handleCellNumberChange}
              />
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col xs={24} md={10}>
            <Form.Item
              name="homeProvince"
              label="Home province"
              rules={[
                {
                  required: true,
                  message: "Please select your home province",
                },
              ]}
            >
              <Select onChange={onHomeProvinceChange}>
                {provinces.map((province) => (
                  <Option key={province.key}>{province.value}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col span={2}></Col>

          <Col xs={24} md={10}>
            <Form.Item
              name="address"
              label="Address"
              rules={[
                {
                  required: true,
                  message: "Please enter your address",
                },
              ]}
            >
              {!showAddressInfo && (
                <Button onClick={() => setShowModal(true)}>
                  Add Address
                </Button>
              )}
              <div
                style={{ maxWidth: 300, display: "flex", marginBottom: 20 }}
              >
                {showAddressInfo && (
                  <Card
                    style={{
                      width: "100%",
                      justifyContent: "center",
                      marginBottom: 10,
                      backgroundColor: "rgb(250 250 250)",
                      borderBlockStyle: "solid",
                      borderColor: "#CCC",
                    }}
                  >
                    <Meta
                      avatar={<Avatar icon={<GlobalOutlined />} />}
                      title="Local Address"
                      description={`${address.street} ${address.cityOrTown} ${address.province} ${address.postalCode}`}
                    />
                  </Card>
                )}
              </div>
            </Form.Item>
          </Col>
          <Col span={2}></Col>
          <Col xs={24} md={10}>
            <Form.Item
              name="email"
              label="Email Address"
              rules={[
                {
                  required: true,
                  message: "Please enter your cellphone",
                },
              ]}
            >
              <Input name="email" />
            </Form.Item>
          </Col>
        </Row>
        <Card
          title="Preferred Placement and Employment Details"
          variant={true}
          styles={{ header: { border: 0, textAlign: "center" }}}
        >
          <Row>
            <Col xs={24} md={10}>
              <Form.Item
                name="preferredProvince"
                label="Preferred placement province"
                rules={[
                  {
                    required: true,
                    message: "Please select your preferred placement province",
                  },
                ]}
              >
                <Select>
                  {provinces.map((province) => (
                    <Option key={province.key}>{province.value}</Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={2}></Col>
            <Col xs={24} md={10}>
              <Form.Item
                name="preNYSActivity"
                label="Current employment status"
                rules={[
                  {
                    required: true,
                    message: "Please select your current employment status",
                  },
                ]}
              >
                <Select>
                  {activities.map((activity) => (
                    <Option key={activity.key} value={activity.value}>
                      {activity.value}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Card
          title="Alternative Contact Person"
          variant={true}
          styles={{ header: {border: 0, textAlign: "center"} }}
        >
          <Row>
            <Col xs={24} md={10}>
              <Form.Item
                name="alternativePersonFullName"
                label="Full name"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <Input name="alternativePersonFullName" />
              </Form.Item>
            </Col>
            <Col span={2}></Col>
            <Col xs={24} md={10}>
              <Form.Item
                name="alternativeCellNumber"
                label="Cellphone No"
                rules={[
                  {
                    required: false,
                  },
                ]}
              >
                <ContactField
                  contactValue={altContactValue}
                  onContactChange={handleCellNumberChange}
                />
              </Form.Item>
            </Col>
          </Row>
        </Card>
        <Row>
          <Col span={20}></Col>
          <Col span={3}>
            {/* <Button key="2" htmlType="submit" form={formName} type="primary">
              Save
            </Button> */}
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default PersonalInformation;
